(function () {
  'use strict';

  class LetterScroll {
    constructor(container) {
      this.container = container;
      this.targets = [];
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
      this.splitLetters();
      this.collectTargets();
      if (!this.targets.length) {
        return;
      }
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize, { passive: true });
      this.onResize();
    }

    splitLetters() {
      const letterNodes = this.container.querySelectorAll('[data-letter-scroll]');
      letterNodes.forEach((node) => {
        if (node.dataset.letterScrollInitialized === 'true') {
          return;
        }
        this.wrapTextNodes(node);
        node.dataset.letterScrollInitialized = 'true';
      });
    }

    wrapTextNodes(root) {
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(textNode) {
            if (!textNode.parentNode) {
              return NodeFilter.FILTER_REJECT;
            }
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      const textNodes = [];
      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach((textNode) => {
        const text = textNode.nodeValue;
        if (text == null || text.length === 0) {
          return;
        }

        const fragment = document.createDocumentFragment();

        for (let i = 0; i < text.length; i += 1) {
          const char = text[i];
          if (char === '\r') {
            continue;
          }
          const span = document.createElement('span');
          span.className = 'mt-letter';
          span.textContent = char === '\n' ? ' ' : char;
          fragment.appendChild(span);
        }

        textNode.parentNode.insertBefore(fragment, textNode);
        textNode.parentNode.removeChild(textNode);
      });
    }

    collectTargets() {
      this.targets = Array.from(this.container.querySelectorAll('[data-letter-scroll]')).map((node) => {
        const start = this.getPercentage(node.dataset.letterScrollStart, 0);
        const end = this.getPercentage(node.dataset.letterScrollEnd, 100);
        const letters = Array.from(node.querySelectorAll('.mt-letter'));
        return {
          node,
          letters,
          start,
          end,
          lastActive: -1
        };
      });
    }

    getPercentage(value, fallback) {
      const num = parseFloat(value);
      if (Number.isFinite(num)) {
        return Math.min(100, Math.max(0, num));
      }
      return fallback;
    }

    onResize() {
      this.targets.forEach((target) => {
        const rect = target.node.getBoundingClientRect();
        const scrollTop = window.scrollY || window.pageYOffset || 0;
        target.top = rect.top + scrollTop;
        target.height = rect.height;
      });
      this.update();
    }

    onScroll() {
      if (this.ticking) {
        return;
      }
      this.ticking = true;
      window.requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollTop = window.scrollY || window.pageYOffset || 0;

      this.targets.forEach((target) => {
        const { letters, start, end } = target;
        if (!letters.length) {
          return;
        }

        const elementTop = target.top - viewportHeight;
        const elementBottom = target.top + target.height;
        const totalDistance = elementBottom - elementTop || 1;
        const progressRaw = (scrollTop - elementTop) / totalDistance;
        const clamped = Math.min(1, Math.max(0, progressRaw));

        const adjustedStart = start / 100;
        const adjustedEnd = end / 100;
        const normalized = adjustedEnd === adjustedStart
          ? (clamped >= adjustedEnd ? 1 : 0)
          : (clamped - adjustedStart) / (adjustedEnd - adjustedStart);
        const progress = Math.min(1, Math.max(0, normalized));

        const activeCount = Math.round(progress * letters.length);

        if (activeCount === target.lastActive) {
          return;
        }
        target.lastActive = activeCount;

        letters.forEach((letter, index) => {
          if (index < activeCount) {
            letter.classList.add('is-active');
          } else {
            letter.classList.remove('is-active');
          }
        });
      });
    }

    destroy() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      this.targets = [];
    }
  }

  const instances = new Map();

  function init(container) {
    if (instances.has(container)) {
      return;
    }
    const instance = new LetterScroll(container);
    if (instance.targets.length) {
      instances.set(container, instance);
    }
  }

  function initAll(root = document) {
    const sections = root.querySelectorAll('.mt-split-media');
    sections.forEach((section) => init(section));
  }

  function destroy(container) {
    const instance = instances.get(container);
    if (instance) {
      instance.destroy();
      instances.delete(container);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.mt-split-media');
    if (section) {
      destroy(section);
    }
  });
})();


